import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { PulseProduct } from 'shared/core/config/product.types';
import { ProductService } from 'shared/core/services/product.service';

/**
 * Route guard that restricts access to routes based on the current product context.
 * Routes not matching the current product redirect to /404.
 *
 * Usage in routes:
 *   canActivate: [productGuard('insight', 'pro')]
 */
export function productGuard(...allowedProducts: PulseProduct[]): CanActivateFn {
    return (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const productService = inject(ProductService);
        const router = inject(Router);

        const product = productService.getProductFromUrl(state.url);

        if (allowedProducts.includes(product)) {
            return true;
        }
        return router.createUrlTree(['/404']);
    };
}
